/**
 * A list, whatever the backend actually sent.
 *
 * The v3 list endpoints return `{}` rather than `[]` for an empty collection, so every fetch
 * boundary has to coerce before it maps or spreads. `?? []` is not enough: `{}` is not nullish, so
 * it survives the nullish check and then throws on `.map`.
 *
 * Use it at the boundary where the response is read, not deeper in the app.
 */
export function asList<T>(value: readonly T[] | null | undefined): T[]
export function asList<T = unknown>(value: unknown): T[]
export function asList(value: unknown): unknown[] {
	return Array.isArray(value) ? value : []
}
